import React from "react";
import { Checkbox } from "antd";
import { Box } from "@mui/material";

const GlobalFilterCheckbox = ({ checked, indeterminate, onChange, disabled }) => (
  <Box sx={{
    mr: "8px",
    ".ant-checkbox-inner": { borderColor: "#9F9F9F !important" },
    ".ant-checkbox-checked .ant-checkbox-inner": {
      backgroundColor: "#6D72F6 !important",
      borderColor: "#6D72F6 !important",
    },
    ".ant-checkbox-indeterminate .ant-checkbox-inner::after": {
      backgroundColor: "#6D72F6 !important",
    },
  }}>
    <Checkbox
      checked={checked}
      indeterminate={indeterminate}
      onChange={onChange}
      disabled={disabled}
    />
  </Box>
);

export default GlobalFilterCheckbox;
